import { Link } from "@tanstack/react-router";
import { Phone, CalendarCheck } from "lucide-react";
import { BUSINESS } from "./constants";

export function MobileStickyBar() {
  return (
    <div className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-black border-t-2 border-cta shadow-[0_-4px_16px_-6px_rgba(0,0,0,0.6)]"
         style={{ paddingBottom: "env(safe-area-inset-bottom)" }}>
      <div className="grid grid-cols-2 gap-2 p-2">
        <a href={BUSINESS.phoneHref} className="btn-cta text-sm !py-3 !min-h-12">
          <Phone className="size-4" /> Call Now
        </a>
        <Link to="/contact" className="inline-flex items-center justify-center gap-2 bg-black text-cta border-2 border-cta font-display font-bold uppercase tracking-wider rounded-md py-3 text-sm min-h-12">
          <CalendarCheck className="size-4" /> Free Inspection
        </Link>
      </div>
    </div>

  );
}
